import { RECEIVABLES, PAYABLES } from '../constants/LedgerTypes';
import { isIntermodalShipmentType } from './shipment-types';
export const getUnprocessedItems = (shipment, ledgerType) => {
    return (shipment[ledgerType] || []).filter((adj) => !adj.processed);
};
export const getUnprocessedReceivables = (shipment) => {
    return getUnprocessedItems(shipment, RECEIVABLES);
};
export const getUnprocessedPayables = (shipment) => {
    return getUnprocessedItems(shipment, PAYABLES);
};
export const mapIsUnappliedAdjustment = (shipment) => (lineItem) => isIntermodalShipmentType(shipment) && !lineItem.equipment;
export function getOutstandingTotal(shipment, ledgerType) {
    return getUnprocessedItems(shipment, ledgerType).reduce((total, item) => {
        return total + (item.value || 0);
    }, 0);
}
